import React from 'react';
import { Container, Typography, Box, Paper, Divider, Stack, Grid, TextField, Button, Alert } from '@mui/material';
import { Email as EmailIcon, LocationOn as LocationIcon, Phone as PhoneIcon } from '@mui/icons-material';

export default function ContactUs() {
  const handleSubmit = (event) => {
    event.preventDefault();
    alert("Thank you for your message! We will get back to you shortly.");
  };

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" fontWeight={700} textAlign="center" gutterBottom>
        Get in Touch
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" textAlign="center" sx={{ mb: 6, maxWidth: 600, mx: 'auto' }}>
        Have questions about our AI study tools or need support? We're here to help you succeed.
      </Typography>

      <Grid container spacing={6}>
        {/* Contact Info */}
        <Grid item xs={12} md={5}>
          <Stack spacing={4}>
            <Paper elevation={0} sx={{ p: 4, bgcolor: 'primary.main', color: 'primary.contrastText', borderRadius: 2 }}>
              <Typography variant="h6" fontWeight={700} gutterBottom>Contact Information</Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mb: 4 }}>
                Fill out the form or reach us directly via email. We usually respond within 24 hours.
              </Typography>
              
              <Stack spacing={3}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <EmailIcon />
                  <Typography>support@arithmeticinfotech.com</Typography>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center">
                  <PhoneIcon />
                  <Typography>+91 98765 43210</Typography>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center">
                  <LocationIcon />
                  <Typography>Bengaluru, Karnataka, India</Typography>
                </Stack>
              </Stack>
            </Paper>

            <Box>
              <Typography variant="h6" gutterBottom fontWeight={600}>Operating Hours</Typography>
              <Typography variant="body2" color="text.secondary">Monday - Friday: 9:00 AM - 6:00 PM IST</Typography>
              <Typography variant="body2" color="text.secondary">Saturday: 10:00 AM - 2:00 PM IST</Typography>
            </Box>
          </Stack>
        </Grid>

        {/* Contact Form */}
        <Grid item xs={12} md={7}>
          <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField required fullWidth label="First Name" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField required fullWidth label="Last Name" variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                  <TextField required fullWidth type="email" label="Email Address" variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                  <TextField required fullWidth label="Subject" variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    multiline
                    rows={4}
                    label="Message"
                    variant="outlined"
                    placeholder="How can we help you today?"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" size="large" fullWidth>
                    Send Message
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
